const crearCliente = async (cliente, email) => {
  console.log("pasando ala funciona  crearCliente", cliente);
  const url = "https://sistemas.poliarte.com.mx:3000/crear-cliente";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      params: JSON.stringify({ customer: cliente }),
      mail_custumer: email,
    },
    body: cliente,
  });
  const data = await response.json();
  console.log("pasando ala funciona  response", response);
  if (response.ok) {
    console.log("Cliente creado exitosamente", data);
  } else {
    console.error("Error al crear el cliente:", data.errors);
  }
};
const form = document.getElementById("contact-form");
if( form ){ 
 form.addEventListener("submit", function (event) {
   event.preventDefault();
   const formData = new FormData(form);
   const name = formData.get("name");
   const email = formData.get("email");
   const date = formData.get("date");
   console.log("Nombre del bebe:", name);
   console.log("Correo electrónico:", email);
   console.log("fecha de nacimiento", date);
   const cliente = {
     first_name: name,
     last_name: ".",
     email: email,
     metafields: [
       {
         namespace: "custom",
         key: "fecha_de_nacimiento_del_beb",
         value: date,
         type: "date",
       },
       {
         namespace: "custom",
         key: "nombre_del_beb_",
         value: name,
         type: "single_line_text_field",
       },
     ],
   };
   crearCliente(cliente, email);
   function calcularDiferenciaMeses(fechaInicio, fechaFin) {
     const fecha1 = new Date(fechaInicio);
     const fecha2 = new Date(fechaFin);
     const diferenciaAnios = fecha2.getFullYear() - fecha1.getFullYear();
     const diferenciaMeses = fecha2.getMonth() - fecha1.getMonth();
     const totalMeses = diferenciaAnios * 12 + diferenciaMeses;
     return totalMeses;
   }
   const fechaInicio = date;
   const fechaFin = new Date();
   const meses = calcularDiferenciaMeses(fechaInicio, fechaFin);
   console.log("Número de meses:", meses);
   if (meses <= 2) {
     window.location.assign(
       "https://851e4a-07.myshopify.com/products/etapa1?date=" + date
     );
   } else if (meses >= 3 && meses <= 5) {
     window.location.assign(
       "https://851e4a-07.myshopify.com/products/etapa2?date=" + date
     );
   } else if (meses > 5 && meses <= 7) {
     window.location.assign(
       "https://851e4a-07.myshopify.com/products/etapa3?date=" + date
     );
   } else if (meses >= 8) {
     window.location.assign(
       "https://851e4a-07.myshopify.com/products/etapa4?date=" + date
     );
   } else {
     console.log("No paso en ninguna de las opciones saludos...", meses);
     window.location.assign(
       "https://851e4a-07.myshopify.com/products/etapa4?date=" + date
     );
   }
 });
}
